import uniqBy from 'lodash/uniqBy'
import map from 'lodash/map'
import filter from 'lodash/filter'
import Moment from 'moment-timezone'
import i18nConfig from 'config/i18n'
import { BEST_CARS, TOP_DESTINATIONS } from 'config/landing-pages'

export default {
  data() {
    return {
      selectedRental: null,
      selectedRegion: null,
      selectedCountry: null,
      bestDeals: null,
      locale: this.$i18n.locale,
      dealsList: [],
      dealsListFiltered: []
    }
  },

  mounted() {
    if (!['top-destinations', 'DefaultLayout'].some(v => v === this.$options.name)) this.loadPromotions()
  },

  computed: {
    rentals() {
      if (this.promotions) {
        return uniqBy(map(this.promotions, (v) => { return { value: v.id_locadora, label: v.locadora } }), v => v.value)
      }

      return []
    },

    filteredPromotions() {
      let filteredPromotions = this.promotions

      if (this.selectedRental) {
        filteredPromotions = filter(filteredPromotions, v => v.id_locadora === parseInt(this.selectedRental, 10))
      }

      if (this.selectedRegion) {
        filteredPromotions = filter(filteredPromotions, v => v.id_pais === parseInt(this.selectedRegion, 10) || v.continente.toLowerCase() === this.selectedRegion.toLowerCase())
      }

      return filteredPromotions
    },

    allRegions() {
      return [
        {
          label: this.$t('select.country'),
          options: [
            { value: 1, label: this.$t('location.brazil') },
            { value: 2, label: this.$t('location.usa') }
          ]
        },
        {
          label: this.$t('select.region'),
          options: [
            { value: 'america-do-norte', label: this.$t('continent.northamerica') },
            { value: 'america-central', label: this.$t('continent.centralamerica') },
            { value: 'america-do-sul', label: this.$t('continent.southamerica') },
            { value: 'europa', label: this.$t('continent.europa') },
            { value: 'asia', label: this.$t('continent.asia') },
            { value: 'oceania', label: this.$t('continent.oceania') }
          ]
        }
      ]
    }
  },

  methods: {
    /**
    * @desc checks if is NORMAL phase event
    * @returns {Boolean}
    */
    isNormal() {
      return (!this.isPre() && !this.isEsquenta() && !this.isPromo() && !this.isFinished())
    },

    /**
    * @desc checks if is PRE phase event
    * @returns {Boolean}
    */
    isPre() {
      const curDate = new Moment(this.currentDate)
      const preStarts = new Moment(this.dates[this.$i18n.locale].pre_starts)
      const preEnds = new Moment(this.dates[this.$i18n.locale].pre_ends)
      const conditions = curDate >= preStarts && curDate <= preEnds

      return (conditions || (this.isCheckedUrlToken && conditions))
    },

    /**
    * @desc checks if is ESQUENTA phase event
    * @returns {Boolean}
    */
    isEsquenta() {
      const curDate = new Moment(this.currentDate)
      const esquentaStarts = new Moment(this.dates[this.$i18n.locale].esquenta_starts)
      const esquentaEnds = new Moment(this.dates[this.$i18n.locale].esquenta_ends)
      const conditions = curDate >= esquentaStarts && curDate <= esquentaEnds

      return (conditions || (this.isCheckedUrlToken && conditions))
    },

    /**
    * @desc checks if is PROMO phase event
    * @returns {Boolean}
    */
    isPromo() {
      const curDate = new Moment(this.currentDate)
      const promoStarts = new Moment(this.dates[this.$i18n.locale].promo_starts)
      const promoEnds = new Moment(this.dates[this.$i18n.locale].promo_ends)
      const conditions = curDate >= promoStarts && curDate <= promoEnds

      return (conditions || (this.isCheckedUrlToken && conditions))
    },

    /**
    * @desc checks if the event has FINISHED
    */
    isFinished() {
      const curDate = new Moment(this.currentDate)
      const finishStarts = new Moment(this.dates[this.$i18n.locale].finish_starts)
      const finishEnds = new Moment(this.dates[this.$i18n.locale].finish_ends)
      const conditions = curDate >= finishStarts && curDate <= finishEnds

      return (conditions || (this.isCheckedUrlToken && conditions))
    },

    /**
     * @desc return list of best cars by locale
     * @param {String} locale
     * @returns {Array<Object>}
     */
    getBestCars(locale) {
      return (locale in BEST_CARS) ? BEST_CARS[locale] : BEST_CARS[i18nConfig.defaultLocale]
    },

    async loadBestDeals() {
      const endpoint = (process.env.NODE_ENV === 'production') ? `promo_locadoras_${this.$store.getters.getLocale}.json` : `promo/promo_locadoras_${this.$store.getters.getLocale}_lan.json`
      await this.$promotionsCdn.get(endpoint)
        .then((result) => {
          this.bestDeals = result.data
        }).catch(() => {
          this.bestDeals = false
        })
    },

    async loadPromotions() {
      const paramDeals = {
        locale: this.$store.getters.getLocale,
        url: this.$route.path
      }

      const dealsList = await this.$rentcarsApi
        .get('v1/deal', paramDeals)
        .catch((e) => {
        })
      this.dealsList = dealsList && dealsList.hasOwnProperty('data') ? dealsList.data.Success : []

      if (this.dealsList.length > 0 && this.selectedRental !== undefined) {
        this.dealsListFiltered = this.filterDealsList()
      }

      this.loadBestDeals()
    },

    filterDealsList() {
      let filterDeals = this.dealsList

      if (this.selectedRental && this.selectedCountry) {
        filterDeals = filter(filterDeals, v => (
          (v.countries.includes(this.selectedCountry) && v.rentalCompanyId === parseInt(this.selectedRental, 10))
        ))
      } else if (this.selectedRental) {
        filterDeals = filter(filterDeals, v => v.rentalCompanyId === parseInt(this.selectedRental, 10))
      }

      return filterDeals
    },

    /**
    * @desc return list of best cars by locale
    * @param {String} locale
    * @returns {Array<Object>}
    */
    getTopDestinations(locale) {
      return (locale in TOP_DESTINATIONS) ? TOP_DESTINATIONS[locale] : TOP_DESTINATIONS[i18nConfig.defaultLocale]
    }
  }
}
